export const BA_ROUTES = {
  STARTUP: 'STARTUP',
  AUTHORIZE: 'AUTHORIZE',
  BUSINESS_DATA: 'BUSINESS_DATA',
  OTP: 'OTP',
  REP_DATA: 'REP_DATA',
  CONFIGURATION: 'CONFIGURATION',
  SUCCESS: 'SUCCESS',
  DATA_COLLECTION: 'DATA_COLLECTION'
} as const;
